/*
 * 我的数字员工API
 * */
import services from "../config/axios";
import base from "./base";

const dEmpAPI = {
    // 获取我的数字员工列表
    getDEmpList<T>(params: FormData) {
        return services.post(`${base.lk}/DEmp/GetDEmpList`, params);
    },
    //获取一个数字员工信息
    getDEmpOne<T>(params: FormData) {
        return services.post(`${base.lk}/DEmp/GetDEmpOne`, params);
    },
    // 添加本地任务
    addJobLocal<T>(params: FormData) {
        return services.post(`${base.lk}/DEmp/AddJobLocal`, params);
    },
};

export default dEmpAPI;
